import { AppLink } from '../@types'

export const APP_LINKS: Array<AppLink> = [
  {
    label: 'Alunos',
    link: '/admin/students',
    icon: (
      <img
        src="/icons/student.svg"
        className="w-[1.4rem] h=[1.4rem]"
        alt="ícone"
      />
    ),
    roles: ['ADMIN', 'TEACHER', 'FINANCE'],
  },
  {
    label: 'Módulos',
    link: '/admin/modules',
    icon: (
      <img
        src="/icons/modules.svg"
        className="w-[1.4rem] h=[1.4rem]"
        alt="ícone"
      />
    ),
    roles: ['ADMIN', 'TEACHER'],
  },
  {
    label: 'Aulas',
    link: '/admin/lessons',
    icon: (
      <img
        src="/icons/play_video.svg"
        className="w-[1.4rem] h=[1.4rem]"
        alt="ícone"
      />
    ),
    roles: ['ADMIN', 'TEACHER'],
  },
  {
    label: 'Testes e Exames',
    link: '/admin/assessments',
    icon: (
      <img
        src="/icons/tests_&_exams.svg"
        className="w-[1.4rem] h=[1.4rem]"
        alt="ícone"
      />
    ),
    roles: ['ADMIN', 'TEACHER'],
  },
  {
    label: 'Pacotes',
    link: '/admin/packages',
    icon: (
      <img
        src="/icons/bill-package.svg"
        className="w-[1.4rem] h=[1.4rem]"
        alt="ícone"
      />
    ),
    roles: ['ADMIN', 'FINANCE'],
  },
  {
    label: 'Pagamentos',
    link: '/admin/bills',
    icon: (
      <img
        src="/icons/payments_logs.svg"
        className="w-[1.4rem] h=[1.4rem]"
        alt="ícone"
      />
    ),
    roles: ['ADMIN', 'FINANCE'],
  },
  {
    label: 'Documentos',
    link: '/admin/documents',
    icon: (
      <img
        src="/icons/documents.svg"
        className="w-[1.4rem] h=[1.4rem]"
        alt="ícone"
      />
    ),
    roles: ['ADMIN', 'FINANCE'],
  },
  {
    label: 'Definições',
    link: '/admin/settings',
    icon: (
      <img
        src="/icons/settings.svg"
        className="w-[1.4rem] h=[1.4rem]"
        alt="ícone"
      />
    ),
    roles: ['ADMIN', 'FINANCE', 'TEACHER'],
  },
]
